'use strict';

module.exports = {
  ACTIONS_ID: 'Nav',
  STORE_NAME: 'Nav',
};


// WEBPACK FOOTER //
// ./src/app/dash/nav/NavConstants.js